import { getRepository } from '@things-factory/shell'

import { TutorialRole } from '../../../entities'

export const tutorialRoleResolver = {
  async tutorialRole(_: any, { name }, context: ResolverContext) {
    const { domain } = context.state

    return await getRepository(TutorialRole).findOne({
      where: { domain: { id: domain.id }, name },
      relations: ['domain', 'creator', 'updater']
    })
  }
}
